'use client';

import Button from '@/components/ui/button';
import { FAQ, ProductFAQ } from '@/types/product_page/productType';
import React, { useState } from 'react';

const FaqElement = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => (
  <div className="p-6 h-full w-full rounded-xl border border-border-gray min-h-[200px] flex flex-col gap-3">
    <h2 className="text-black text-2xl font-bold">{title}</h2>
    <p
      dangerouslySetInnerHTML={{ __html: description }}
      className="text-off-black font-proxima_font"
    ></p>
  </div>
);

const FaqSection = ({ data }: { data: ProductFAQ[] }) => {
  const [showAll, setShowAll] = useState(false);

  const faqsToShow = showAll ? data : data.slice(0, 5);

  return (
    <section id="faqs" className="w-full h-full py-6 md:py-10 px-4 md:px-6">
      <h1 className="text-3xl font-bold text-center mb-6 md:mb-12">
        Frequently Asked Questions
      </h1>
      <div className="max-w-7xl w-full h-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        {faqsToShow.map((item, index) => (
          <FaqElement
            key={index}
            title={item.question_faq_translations_id.question.question}
            description={item.question_faq_translations_id.answer.answer}
          />
        ))}

        <div className="p-6 w-full h-full rounded-xl border border-border-gray flex flex-col justify-between gap-10">
          <h2 className="text-black text-2xl font-bold">
            Have other questions?
          </h2>
          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              label="Contact us"
              to={'/contact-us'}
              className="text-sm lg:text-sm border-border-gray text-nowrap hover:border-black"
            />
            <Button
              variant="main"
              animation="none"
              label={showAll ? 'Show Less' : 'See All FAQs'}
              className="text-sm lg:text-sm !text-nowrap"
              onClick={() => setShowAll(!showAll)}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
